import { useTranslation } from 'react-i18next';
import { AugmentedBuilding, Building, BuildingId } from 'shared/models';
import { BuildingAddress } from 'ui/building/settings/address/buildingAddress/BuildingAddress';
import { NoneProvided } from 'ui/shared/noneProvided';
import { BuildingStatusBars } from '../buildingStatusBars/BuildingStatusBars';
import { TFunction } from 'i18next';
import { VirtualTable } from "ui/shared/virtualTable/VirtualTable";
import { Link } from "react-router-dom";

require('./BuildingList.css');

export type Props = {
    buildings: Record<BuildingId, Building>;
    order: BuildingId[];
    loading?: boolean;
};


// eslint-disable-next-line react/display-name
export const renderStatus = (t: TFunction) => (building: Building) => {
    const { /*devicesOffline = '0',*/ devicesUp = '0', devicesLate1 = '0', devicesLate2 = '0', devicesDown = '0' } = building as AugmentedBuilding;
    const up = parseInt(devicesUp, 10);
    const down = parseInt(devicesDown, 10);
    const late1 = parseInt(devicesLate1, 10);
    const late2 = parseInt(devicesLate2, 10);
    //const hasErrors = down > 0;
    //const hasWarnings = late1 + late2 > 0;
    const allDevicesUp = up > 0 && (down + late1 + late2) === 0;

    return (
        <div className="status-column" >
            <div
                className={ `up-devices-label ${allDevicesUp ? 'all-devices-up' : ''}` }
                title={ allDevicesUp ? t('BUILDINGS.STATUS_ALL_UP') : t('BUILDINGS.STATUS_SOME_UP', [ up, up + down + late1 + late2 ]) }
            >
                { up === 0 ? '' : up }
            </div>
            <div className="summary-bar-chart">
                <BuildingStatusBars
                    up={ parseInt(devicesUp, 10) }
                    late={ late1 + late2 }
                    down={ down }
                />
            </div>
            <div className="down-devices-label"
                title={ down > 0 ? t('BUILDINGS.STATUS_N_DOWN', [ down ]) : '' }
            >
                { down === 0 ? '' : down }
            </div>
        </div>
    );
};

export const renderName = (building: Building) => {
    const { id, urlSlug, displayName } = building as AugmentedBuilding;
    return (
        <div className="name-column">
            <Link
                className="building-link"
                to={ `/buildings/${urlSlug || id}` }
            >
                { displayName || <NoneProvided/> }
            </Link>
            <div className="sub-text">
                <BuildingAddress building={ building }/>
            </div>
        </div>
    );
};

export const BuildingList = ({ buildings, order, loading = false }: Props) => {
    const { t } = useTranslation();

    const columns = [
        { render: renderStatus(t), name: t('BUILDINGS.COLUMN.STATUS') },
        { render: renderName, name: t('BUILDINGS.COLUMN.NAME') },
    ];

    return (
        <VirtualTable
            className="building-list"
            rows={ buildings }
            rowOrder={ order }
            cols={ columns }
            loading={ loading }
            columnSizes={ 'max(4.75em + 40px, 15%)' }
            emptyTableMessage={ t('BUILDINGS.NONE_FOUND') }
            rowElementId={ (b: Building) => `building-${b.id}` }
        />
    );
};
